import type { StateTree } from '@makemydeal/dr-dash-types';
import DealSummaryItem from '../common/DealSummaryItem';

import * as constants from '../../constants';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';
import { useHeldValue } from '../../hooks/useHeldSelector';

const InsufficientFunds = () => {
    const offsetPrice = useHeldValue(
        useTrackedSelector((state: StateTree) => offerReduxSelectors.getCashOffsetAmountAddedToPrice(state), {
            component: 'InsufficientFunds',
            field: 'cashOffsetAmountAddedToPrice'
        })
    );
    const cashOffsetAddedToPrice = formatDollarsAndCents(offsetPrice);
    const { showDetailedView } = useDealSummary();
    return (
        <DealSummaryItem
            label={constants.INSUFFICIENT_FUNDS}
            value={cashOffsetAddedToPrice}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default InsufficientFunds;
